import { IonItem } from '@ionic/react';
import styled from 'styled-components';
import { AllieDefaultColors } from '../../../common/color.types';
import { AllieItemProps } from './Item.types';

const backgroundVars = {
  light: 'light-main',
  transparent: 'transparent',
  neutral: 'neutral-50',
  primary: 'primary-50',
  secondary: 'secondary-50',
  tertiary: 'tertiary-50',
  success: 'success-main',
  warning: 'warning-main',
  error: 'error-main',
};

const defaults: Record<string, AllieDefaultColors> = {
  backgroundColor: 'light',
};

const getBackgroundColor = (backgroundColor?: AllieDefaultColors, variationColor?: string) => {
  if (!variationColor) {
    return backgroundVars[backgroundColor || defaults.backgroundColor];
  }
  return `${backgroundColor}-${variationColor}`;
};

export const StyledItem: any = styled(IonItem)`
  --background: ${(props: AllieItemProps) =>
    `var(--allie-color-${getBackgroundColor(props.backgroundColor, props.variationColor)})`};
  --background-focused: ${(props: AllieItemProps) =>
    `var(--allie-color-${backgroundVars[props.backgroundColor || defaults.backgroundColor]})`};
  --color: ${(props: AllieItemProps) => `var(--allie-color-${props.allieColor})`};
  --background-hover: ${(props: AllieItemProps) =>
    `${props.backgroundHover === 'none' ? 'transparent' : 'currentColor'}`};

  &.item-label-stacked ion-select::part(icon) {
    transform: none;
  }
`;
